module.exports = __webpack_public_path__ + "img/404.202f864d.svg";